import { useTranslation } from "../../../../../hooks";
import FailedImg from "../assets/failed.svg";
import {
  LivenessErrorCode,
  LivenessResult,
  LIvenessStatus,
} from "../../../../../constants";
import SuccessImg from "../assets/success.svg";
import { ResultData } from "../Result.modal";

export const useResultTranslation = (
  data: ResultData | null,
  count: number | null
) => {
  const translate = useTranslation();
  const { status, result, errorCode } = data || {};

  let image = FailedImg;
  let title: string;
  let description: string | undefined;
  let buttonText: string;
  let helperText: string | undefined;

  const successfulCompletion =
    status === LIvenessStatus.Completed && result === LivenessResult.Valid;
  const sessionTimeout =
    status === LIvenessStatus.Error && errorCode === "SESSION_TIMEOUT";
  const notLiveCompletion =
    status === LIvenessStatus.Completed &&
    errorCode === LivenessErrorCode.NotLive;
  const maxAttemptsReached =
    status === LIvenessStatus.Error &&
    errorCode === LivenessErrorCode.MaxAttempts;
  const permissionDenied =
    status === LIvenessStatus.Error &&
    errorCode === LivenessErrorCode.PermissionDenied;

  if (successfulCompletion) {
    image = SuccessImg;
    title = translate("owner_info.liveness.success_modal.title");
    description = translate("owner_info.liveness.success_modal.description");
    buttonText = translate("owner_info.liveness.cta.continue");
  } else if (maxAttemptsReached) {
    title = translate("owner_info.liveness.errors.max_attempts.text");
    buttonText = translate("owner_info.liveness.cta.contact_support");
  } else if (notLiveCompletion && count !== null) {
    title = translate("owner_info.liveness.errors.failed.text");
    helperText = translate("owner_info.liveness.errors.failed.helper_text", [
      `${count - 1}`,
    ]);
    buttonText = translate("owner_info.liveness.cta.retry");
  } else if (sessionTimeout) {
    title = translate("owner_info.liveness.errors.session_timeout.title");
    description = translate(
      "owner_info.liveness.errors.session_timeout.description"
    );
    buttonText = translate("owner_info.liveness.errors.session_timeout.cta");
  } else if (permissionDenied) {
    title = translate("owner_info.liveness.errors.permission.title");
    description = translate(
      "owner_info.liveness.errors.permission.description"
    );
    buttonText = translate("owner_info.liveness.errors.permission.cta");
  } else {
    title = translate("owner_info.liveness.errors.general.title");
    description = translate("owner_info.liveness.errors.general.description");
    buttonText = translate("owner_info.liveness.errors.general.cta");
  }

  return {
    image,
    title,
    description,
    buttonText,
    helperText,
  };
};
